import React, { type ReactNode } from 'react';
import { Button } from '@noths/polaris-design-system-core-components';

import { NumericalLozenge } from 'src/components/atoms/NumericalLozenge/NumericalLozenge';
import type { ListingsHeaderRootCSS } from 'src/components/organisms/ListingsHeader/ListingsHeader.styles';
import * as styles from 'src/components/organisms/ListingsHeader/ListingsHeader.styles';

export interface ListingsHeaderProps {
  /** Scrolls sideways beside the button, behind a divider. */
  children?: ReactNode;
  onButtonClick: () => void;
  stickyOffsetPx?: number;
  totalActiveFacetOptions: number;
}

export const ListingsHeader = ({
  children,
  onButtonClick,
  stickyOffsetPx = 0,
  totalActiveFacetOptions,
}: ListingsHeaderProps) => {
  const accessibleFilterLabel = `Filter options (${totalActiveFacetOptions} selected)`;

  return (
    <div
      css={styles.listingsHeaderRoot}
      style={
        {
          '--listingsHeaderTop': `${stickyOffsetPx}px`,
        } as ListingsHeaderRootCSS
      }
    >
      <Button
        aria-label={accessibleFilterLabel}
        compact
        iconLeft="filter"
        onClick={onButtonClick}
        type="button"
      >
        Filters
        {totalActiveFacetOptions > 0 && (
          <NumericalLozenge
            value={totalActiveFacetOptions > 99 ? '99+' : `${totalActiveFacetOptions}`}
          />
        )}
      </Button>
      <div css={styles.listingsHeaderSlot}>{children}</div>
    </div>
  );
};
